import {
  Linkedin,
  Facebook,
  Mail,
  Phone,
  MapPin,
  MessageCircle
} from "lucide-react";
import logo from "/src/assets/Logo.png";

const QUICK = ["Home", "About Us", "Services", "Training", "Certifications", "Contact Us"];
const SERVICES = [
  "Crane Inspection & Maintenance",
  "Lifting Equipment Inspection",
  "Non Destructive Testing (NDT)",
  "Rope Access Inspection",
  "DROPS Inspection Services",
  "Load Testing Services",
  "CCU Inspection & Fabrication",
  "Overhauling & Refurbishment",
];
const socialLinks = [
  {
    icon: Linkedin,
    url: "https://www.linkedin.com/company/solid-proof-energy/"
  },
  {
    icon: Facebook,
    url: "https://www.facebook.com/profile.php?id=61591590911831&mibextid=wwXIfr&rdid=wo0okD8Ha594oTkJ&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F18rX3U2Uui%2F%3Fmibextid%3DwwXIfr#"
  }
];
/* const CERTS = [
  "API Spec Q1",
  "ISO 9001:2015",
  "ISO 45001",
  "LEEA Member",
  "DNV Approved",
  "ASNT Level III",
]; */

export function Footer() {
  const link = (label: string) => {
    const id = label.toLowerCase().replace(/[^a-z]/g, "");
    const map: Record<string, string> = {
      home: "home",
      aboutus: "about",
      services: "services",
      training: "training",
      certifications: "certifications",
      contactus: "contact",
    };
    return map[id] || "contact";
  };

  return (
    <footer className="bg-navy-deep text-white">
      <div className="container-x py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center ">
              <span className="grid place-items-center rounded-md  text-white">
                <img src={logo} className="h-[140px] w-full" />
              </span>
              <div>
                <div className="text-[16px] font-black tracking-tight">SOLID PROOF ENERGY</div>

              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/70">
              Independent inspection, certification, training and engineering services trusted by
              the world's most demanding offshore and industrial operators.
            </p>
              <div className="mt-6 flex gap-2">
              {socialLinks.map((item, i) => (
                <a
                  key={i}
                  href={item.url}
                  target="_blank"
                  aria-label="social"
                  className="grid h-10 w-10 place-items-center rounded-md border border-white/15 text-white/80 transition-colors hover:bg-orange hover:border-orange hover:text-white"
                >
                  <item.icon className="h-4 w-4" />
                </a>
              ))}
            </div>

          </div>

          <FooterCol title="Quick Links">
            {QUICK.map((q) => (
              <li key={q}>
                <a href={`#${link(q)}`} className="hover:text-orange">
                  {q}
                </a>
              </li>
            ))}
          </FooterCol>

          <FooterCol title="Services">
            {SERVICES.map((q) => (
              <li key={q}>
                <a href={`#services-${q.replace(/\s+/g, "-").toLowerCase()}`} className="hover:text-orange">
                  {q}
                </a>
              </li>
            ))}
          </FooterCol>

          {/*  <FooterCol title="Certifications">
            {CERTS.map((q) => (
              <li key={q}>{q}</li>
            ))}
          </FooterCol> */}

          <div className="lg:col-span-2">
            <div className="text-xs font-bold uppercase tracking-widest text-orange">Contact</div>
            <ul className="mt-5 space-y-3 text-sm text-white/75">
              <li className="flex gap-2" >
                <MapPin className="h-4 w-4 shrink-0 text-orange" /> Cairo, Egypt
              </li>
              <a href="tel:+201096466561" className="flex gap-2">
                <li className="flex gap-2">
                  <Phone className="h-4 w-4 shrink-0 text-orange" /> +20 109 646 6561
                </li>
              </a>

              <a href="tel:+201509080807" className="flex gap-2">
                <li className="flex gap-2">
                  <Phone className="h-4 w-4 shrink-0 text-orange" /> +20 150 908 0807
                </li>
              </a>

               <a href="https://wa.me/201096466561" className="flex gap-2">
                <li className="flex gap-2">
                  <MessageCircle className="h-4 w-4 shrink-0 text-orange" /> +20 109 646 6561
                </li>
              </a>
              
              <a href="mailto:info@solidproofenergy.com">
                <li className="flex gap-2  ">
                  <Mail className="h-4 w-4 shrink-0 text-orange" /> info@solidproofenergy.com
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-center justify-between gap-3 py-6 text-xs text-white/60 sm:flex-row">
          <div>© {new Date().getFullYear()} Solid Proof Energy. All rights reserved.</div>
          <div className="flex gap-5">

          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="lg:col-span-2">
      <div className="text-xs font-bold uppercase tracking-widest text-orange">{title}</div>
      <ul className="mt-5 space-y-2.5 text-sm text-white/75">{children}</ul>
    </div>
  );
}
